import React from "react";

import "./header.css";

const Header = (props) => {
  return (
    <header className="Header">
      <div className="Sec__spacer"></div>
      <div className="header__container">
        <div className="header__name">
          <span>/</span> VAHID GHODSI <span>/</span>
        </div>
        <div className="header__doc-title"> Curriculum Vitae </div>
        <div className="header__date">
          <span>_</span>Update Date : July 2020
        </div>
      </div>
      <div className="Sec__spacer-end"></div>
    </header>
  );
};

export default Header;
